<template>
  <div v-loading="initLoading">
    <div style="width: 90%;background-color: #fafafa;padding: 20px">
      <div style="font-size: 20px">
        <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
          <el-breadcrumb-item :to="{ path: '/console' }">数据中心</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/SupplierInfo' }">业务员权限配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row>
        <el-col :span="24">
          <div style="font-size: 25px;margin-top: 15px;">
            <p>业务员权限配置</p>
          </div>
        </el-col>
      </el-row>

      <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" :inline="true">
        <el-form-item label="供应商" :required="true">
          <el-select v-model="ruleForm2.selectedSupplierId" placeholder="必选" value-key="id" @change="supplierid"
                     style="width: 500px">
            <el-option
              v-for="item in user"
              :key="item.id"
              :label="item.name"
              :value='item.id'
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="数据中心账号" prop="selectSalesman">
          <el-select clearable popper-class="el-select" v-model="ruleForm2.selectedSalesman" multiple
                     style="width: 100%" value-key="centerId" :placeholder="this.placeholders"
                     :disabled="this.disabled">
            <select-all-option v-model="ruleForm2.selectedSalesman" group-value="salesman" :data="selectSalesman"
                               :autoSelect="true"/>
            <el-option-group
              v-for="group in selectSalesman"
              :key="group.name"
              :label="group.name">
              <el-option
                v-for="item in group.salesman"
                :key="item.name"
                :label="item.name"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
      </el-form>

      <div style="margin-left: 64px;margin-bottom: 30px">
        <el-button style="color: white; border-color: #FF6633; background-color: #FF6633" :loading="loading"
                   @click="importManager">导出业务员名单及权限配置表
        </el-button>


        <el-button style="color: white; border-color: #FF6633; background-color: #FF6633" :loading="loading2"
                   @click="uploadManager" :disabled="dashboardSales">上传业务员名单及权限配置表
        </el-button>
        <input type="file" ref="uploadManager" v-show="false" accept=".xls,.xlsx" @change="managerExcel"/>
      </div>

      <div style="width: 100%; font-size: 25px;font-weight: bold">
        <el-tabs v-model="activeName" :before-leave="changTabs" type="border-card" style="width: 100%">
          <el-tab-pane label="全局设置" name="1" v-loading="tabLoading">
            <el-form label-position="top" label-width="80px" :model="queryData">

              <el-form-item label="导购签约与对接">
                <el-select v-model="queryData.saleSign" placeholder="不可签约对接导购" style="width: 70%"
                           :disabled="!editList.saleSign">
                  <el-option
                    v-for="item in formParam.saleSign"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>

                <el-button plain class="cancelBtn"
                           v-if="editList.saleSign" @click="cancel('saleSign')">取消
                </el-button>
                <el-button plain class="submitBtn"
                           v-if="editList.saleSign" @click="updateSupplierManagerConfig('saleSign')">提交
                </el-button>

                <el-button plain class="editBtn"
                           v-if="!editList.saleSign" @click="editList.saleSign = true">编辑
                </el-button>
              </el-form-item>

              <el-form-item label="数据魔方查看范围">
                <el-select v-model="queryData.dashboardSales"
                           placeholder="有数据魔方使用权限（业务员仅能查看自身对接导购的数据）" style="width: 70%"
                           :disabled="!editList.dashboardSales">
                  <el-option
                    v-for="item in formParam.dashboardSales"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>

                <el-button plain class="cancelBtn"
                           v-if="editList.dashboardSales" @click="cancel('dashboardSales')">取消
                </el-button>
                <el-button plain class="submitBtn"
                           v-if="editList.dashboardSales" @click="updateSupplierManagerConfig('dashboardSales')">提交
                </el-button>

                <el-button plain class="editBtn"
                           v-if="!editList.dashboardSales" @click="editList.dashboardSales = true">编辑
                </el-button>
              </el-form-item>

              <el-form-item label="提成规则分配与更改">
                <el-select v-model="queryData.saleActivity"
                           placeholder="可以为导购分配和更改提成规则" style="width: 70%"
                           :disabled="!editList.saleActivity">
                  <el-option
                    v-for="item in formParam.saleActivity"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>

                <el-button plain class="cancelBtn"
                           v-if="editList.saleActivity" @click="cancel('saleActivity')">取消
                </el-button>
                <el-button plain class="submitBtn"
                           v-if="editList.saleActivity" @click="updateSupplierManagerConfig('saleActivity')">提交
                </el-button>

                <el-button plain class="editBtn"
                           v-if="!editList.saleActivity" @click="editList.saleActivity = true">编辑
                </el-button>
              </el-form-item>


              <el-form-item label="已退回申报重新提审">
                <el-select v-model="queryData.ticketReview" placeholder="不可提审已退回申报流程" style="width: 70%"
                           :disabled="!editList.ticketReview">
                  <el-option
                    v-for="item in formParam.ticketReview"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>

                <el-button plain class="cancelBtn"
                           v-if="editList.ticketReview" @click="cancel('ticketReview')">取消
                </el-button>
                <el-button plain class="submitBtn"
                           v-if="editList.ticketReview" @click="updateSupplierManagerConfig('ticketReview')">提交
                </el-button>

                <el-button plain class="editBtn"
                           v-if="!editList.ticketReview" @click="editList.ticketReview = true">编辑
                </el-button>
              </el-form-item>

              <el-form-item label="导购过期小票特别批注结算">
                <el-select v-model="queryData.ignoreTicketTime" placeholder="不可设置过期小票为可继续结算"
                           style="width: 70%" :disabled="!editList.ignoreTicketTime">
                  <el-option
                    v-for="item in formParam.ignoreTicketTime"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>

                <el-button plain class="cancelBtn"
                           v-if="editList.ignoreTicketTime" @click="cancel('ignoreTicketTime')">取消
                </el-button>
                <el-button plain class="submitBtn"
                           v-if="editList.ignoreTicketTime" @click="updateSupplierManagerConfig('ignoreTicketTime')">
                  提交
                </el-button>

                <el-button plain class="editBtn"
                           v-if="!editList.ignoreTicketTime"
                           @click="editList.ignoreTicketTime = true">编辑
                </el-button>
              </el-form-item>

              <el-form-item label="当前账号的区域管理员">
                <el-select v-model="queryData.areaAccountManager" placeholder="请选择区域账号管理员的通路管理助手账号"
                           value-key="manager_id" clearable multiple
                           style="width: 70%" :disabled="!editList.areaAccountManager">
                  <el-option
                    v-for="item in allManager"
                    :key="item.manager_id"
                    :label="item.name"
                    :value="item">
                  </el-option>
                </el-select>

                <el-button plain class="cancelBtn"
                           v-if="editList.areaAccountManager" @click="cancel('areaAccountManager')">取消
                </el-button>
                <el-button plain class="submitBtn"
                           v-if="editList.areaAccountManager"
                           @click="updateSupplierManagerConfig('areaAccountManager')">提交
                </el-button>

                <el-button plain class="editBtn"
                           v-if="!editList.areaAccountManager"
                           @click="editList.areaAccountManager = true">编辑
                </el-button>
              </el-form-item>

            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getSupplierInfoByUserId,
  getManager,
  createReportSalesmanExcel,
  putMessageLevelExcel, querySupplierManagerConfig, submitSupplierManagerConfig
} from '@/api/ReportDetailPage'
import selectAllOption from "@/components/selectAllOption";
import {MessageBox} from "element-ui";

export default {
  components: {selectAllOption},
  data() {
    return {
      ruleForm2: {
        selectedSupplierId: '', selectedSalesman: ''
      },
      // 判断供应商是否选择
      rules2: {
        // selectedSupplierId: [
        //   {required: true, message: '请至少选择一个供应商', trigger: 'change'}
        // ]
      },
      user: [],
      value: '',
      selectSalesman: [],
      token: '',
      loading: false,
      loading2: false,
      fileList: [],
      supplierId: '',
      placeholders: '',
      disabled: true,
      managers: '',
      dashboardSales: false,
      objSelect: {},  // 保存当前数据中心账号信息
      initLoading: true,
      tabLoading: false,
      activeName: '1',
      formParam: {
        saleSign: [
          {
            label: '不可签约并对接导购',
            value: 0
          },
          {
            label: '可签约并对接导购（若其他业务员已与导购对接，则无法重新对接）',
            value: 1
          },
          {
            label: '可签约并对接导购（若其他业务员已与导购对接，可重新对接，并覆盖原对接关系）',
            value: 2
          }
        ],
        dashboardSales: [
          {
            label: '无数据魔方使用权限',
            value: 0
          },
          {
            label: '有数据魔方使用权限（业务员能查看所属数据中心账号全部数据）',
            value: 1
          },
          {
            label: '有数据魔方使用权限（业务员仅能查看自身对接导购的数据）',
            value: 2
          }
        ],
        saleActivity: [
          {
            label: '不能为导购分配和更改提成规则',
            value: 0
          },
          {
            label: '可以为导购分配和更改提成规则',
            value: 1
          }
        ],
        ticketReview: [
          {
            label: '不可提审已退回申报流程',
            value: 0
          },
          {
            label: '可以提审已退回申报流程，使平台重新审核',
            value: 1
          }
        ],
        ignoreTicketTime: [
          {
            label: '不能特别批准过期小票',
            value: 0
          },
          {
            label: '可以特别批准过期小票，使之可结算',
            value: 1
          }
        ]
      },
      queryData: {},
      queryDataBak: {},
      allManager: [],
      //控制编辑按钮禁用状态
      editList: {
        saleSign: false,
        dashboardSales: false,
        saleActivity: false,
        ticketReview: false,
        ignoreTicketTime: false,
        areaAccountManager: false
      }
    }
  },
  created() {
    this.$store.commit('addTips', ['每次修改标签时都请重新下载模板后再填写，以避免模板数据与当前数据不符而产生差错',
      '权限配置级别：<span style="color: #ed7043">业务员权限全局设置将覆盖业务员个人权限表，请小心设置。</span>'])
    this.getManagers()
    this.dashboardSales = localStorage.getItem('dashboardSales') == 2 ? true : false
  },
  methods: {
    changTabs() {
      if (this.activeName == 1 && (this.editList.saleSign || this.editList.dashboardSales || this.editList.ticketReview || this.editList.ignoreTicketTime || this.editList.areaAccountManager)) {
        return this.$confirm('当前正在编辑的内容尚未保存，是否要取消修改？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        })
      }
    },
    uploadManager() {
      if (this.ruleForm2.selectedSupplierId == '') {
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
        return
      }
      this.$refs.uploadManager.click()
    },
    managerExcel() {
      this.loading2 = true
      let inputDOM = this.$refs.uploadManager
      let file = inputDOM.files[0]
      let formData = new FormData();
      formData.append("file", file)
      putMessageLevelExcel(this.token, this.ruleForm2.selectedSupplierId, formData).then(r => {
        let {data} = r
        if (data.code == 200)
          this.$notify.success({
            title: '成功',
            message: data.msg,
            position: 'bottom-right'
          })
        if (data.code == 1)
          this.$notify.error({
            title: '错误',
            message: data.msg,
            position: 'bottom-right'
          })
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '数据中心修改失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.loading2 = false
        this.$refs.uploadManager.value = ''
      })
    },
    supplierid() {
      // 根据选择的供应商赋值给品牌和区域
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm2.selectedSupplierId != '') {
        this.querySupplierManagerConfig();

        // console.log(this.user.find(item => item.id == this.ruleForm2.selectedSupplierId))
        this.selectSalesman = [this.user.find(item => item.id == this.ruleForm2.selectedSupplierId)]
        let selectSalesman = []
        if (this.ruleForm2.selectedSalesman.length > 0) {
          this.ruleForm2.selectedSalesman.forEach((item, index) => {
            this.selectSalesman.forEach((e, i) => {
              e.salesman.forEach((t, m) => {
                if (item.centerId == t.centerId) {
                  selectSalesman[item.centerId] = item
                }
              })
            })
          })
          this.ruleForm2.selectedSalesman = Object.values(selectSalesman);
        }
        this.getManagers()
      } else {
        this.ruleForm2.selectedSalesman = []
        this.disabled = true
      }
    },
    allUser(managers) {
      this.token = localStorage.getItem('token')
      getSupplierInfoByUserId(this.token, managers).then(res => {
        if (res.data.suppliers != null && this.user.length == 0) {
          this.user = res.data.suppliers
          if (this.user.length == 1) {
            this.ruleForm2.selectedSupplierId = this.user[0].id;
            this.supplierid();
          }
        }
        this.initLoading = false
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      })
    },
    getManagers() {
      this.token = localStorage.getItem('token')
      getManager(this.token).then(res => {
        this.managers = res.data.date.manager
        if (res.data.date.manager === 0) {
          let {xm} = JSON.parse(sessionStorage.getItem('user'))
          this.placeholders = xm.toUpperCase()
          // 构建当前数据中心账号数据
          this.objSelect = {
            centerId: res.data.date.userId,
            name: this.placeholders
          }
        } else {
          this.placeholders = '可筛选，不筛选则导出全部'
          this.disabled = (this.ruleForm2.selectedSupplierId == '')
        }
        // 进入测页面以后 查询出下拉框的所有值
        this.allUser(this.managers)
      })
    },
    // 导出
    exportTable() {
      this.loading = true
      var dataParam = {
        selectedSalesman: this.ruleForm2.selectedSalesman,
        selectedSupplierId: this.ruleForm2.selectedSupplierId
      }
      createReportSalesmanExcel(this.token, dataParam, this.managers).then(res => {
        if (res !== null) {
          this.$notify({
            type: 'success',
            message: '导出成功',
            title: '成功',
            position: 'bottom-right'
          })
          this.handleDownload(res)
          this.loading = false
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify({
            title: '错误',
            message: '导出错误，请及时联系管理员',
            type: 'error',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    importManager() {
      // 只可控制当前数据中心账号的业务员
      if (this.ruleForm2.selectedSupplierId != '') {
        if (this.managers == 0) {
          this.ruleForm2.selectedSalesman.push(this.objSelect)
          this.exportTable()
        } else {
          if (this.ruleForm2.selectedSalesman != '') {
            this.exportTable()
          } else {
            this.$notify({
              title: '警告',
              message: '请至少选择一个数据中心账号',
              type: 'warning',
              position: 'bottom-right'
            })
          }
        }
      } else {
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
      }
    },
    handleDownload(res) {
      // 创建下载的链接
      // 设置该文件的mime类型，这里对应的mime类型对应为.xlsx格式
      let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = decodeURI(res.headers['filename'])
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    querySupplierManagerConfig() {
      this.tabLoading = true;
      querySupplierManagerConfig(this.token, this.ruleForm2.selectedSupplierId).then(res => {
        if (res.data.code == 200) {
          this.queryData = res.data.data;
          this.queryDataBak = JSON.parse(JSON.stringify(res.data.data));
          this.allManager = res.data.data.allManager;
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => this.tabLoading = false)
    },
    updateSupplierManagerConfig(type) {
      var param = {
        type: type,
        data: this.queryData[type],
        id: this.queryDataBak.id,
        supplierId: this.queryData.supplierId
      }

      if (type == 'areaAccountManager') {
        this.submitData(param, type)
      } else {
        this.$confirm('该设置将应用到当前供应商所有在职业务员，并覆盖所有个人配置数据，是否确认修改？', '', {
          confirmButtonText: '确认修改',
          cancelButtonText: '取消修改',
          center: true,
          showClose: false,
        }).then(() => {
          // console.log(!((this.queryData[type] == this.queryDataBak[type] || this.queryData[type].toString() == this.queryDataBak[type].toString()) && this.queryData.id != null))
          //无修改并且id为null(数据库中无数据)时发请求
          this.submitData(param, type);
        }).catch(() => {
          return;
        });
      }
    },
    submitData(dataParam, type) {
      this.tabLoading = true;
      submitSupplierManagerConfig(this.token, dataParam).then(res => {
        if (res.data.code == 200) {
          this.queryDataBak = JSON.parse(JSON.stringify(res.data.data));
          this.editList[type] = false;
          this.$notify.success({
            title: '成功',
            message: "提交成功",
            position: 'bottom-right'
          })
        } else {
          this.$notify.error({
            title: '错误',
            message: res.data.msg,
            position: 'bottom-right'
          })
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => this.tabLoading = false)
    },
    cancel(type) {
      this.editList[type] = false
      this.queryData[type] = this.queryDataBak[type]
    }
  },
  beforeRouteLeave: function (to, from, next) {
    if (this.editList.saleSign || this.editList.dashboardSales || this.editList.ticketReview || this.editList.ignoreTicketTime || this.editList.areaAccountManager) {
      MessageBox.confirm('当前正在编辑的内容尚未保存，是否要取消修改？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        next()
      }).catch(() => {
        next(false)
      })
    } else {
      next()
    }
  }
}
</script>

<style scoped>
.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.editBtn {
  margin-left: 20px;
  color: #ED7043 !important;
  border-color: #ED7043 !important;
}

.cancelBtn {
  margin-left: 20px;
  background-color: #D8D8D8 !important;
  color: white !important;
}

.submitBtn {
  margin-left: 20px;
  color: white !important;
  background-color: #ed7043 !important;
}
</style>
